// Getting a PDF to someone.
//  • Phones (and recent Chrome/Edge/Safari): the share sheet can hand a PDF *file* to Mail/Gmail/WhatsApp — attached.
//  • Anywhere else a web page cannot attach a file to the user's mail app (mailto: has no attachment support).
//    Then we download the PDF and open a drafted email; or, on paid accounts, the server sends it with the PDF attached.
export function pdfFile(bytes, filename) {
  return new File([bytes], filename, { type: "application/pdf" });
}
export function canShareFiles(file) {
  try { return !!(file && navigator.share && navigator.canShare && navigator.canShare({ files: [file] })); } catch (e) { return false; }
}
// Must be called straight from a click: iOS Safari rejects share() after a long await.
export function sharePdf(file, { title, text }) {
  return navigator.share({ files: [file], title, text });
}
export function downloadFile(file) {
  const url = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url; a.download = file.name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
// "Print": make the real PDF (A4 / Letter) and open it so the viewer's own Print / Share works at full page size.
// The tab is opened inside the click so pop-up blockers allow it; if it still can't open, the PDF downloads instead.
export async function printPdf(makeFile) {
  const w = typeof window !== "undefined" ? window.open("", "_blank") : null;
  try {
    const file = await makeFile();
    if (!w) { downloadFile(file); return; }
    const url = URL.createObjectURL(file);
    w.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 120000);
  } catch (e) { try { w?.close(); } catch (e2) { /* ignore */ } throw e; }
}
export function bytesToBase64(bytes) {
  let bin = ""; const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) bin += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  return btoa(bin);
}
export const safeFilename = (s) => String(s).replace(/[^\w.\- ]+/g, "_").trim();

// One short line at the very bottom of a message. Optional (Settings → Online payments & email); the document itself comes first.
export function brandLine() {
  const o = typeof window !== "undefined" && /^https?:/.test(window.location.origin) ? ` (${window.location.origin})` : "";
  return `Sent with Balance & Beyond${o}`;
}
